// 百度爱番番客服 售前
export default {
  methods: {
    addAffScript() {
      ;(function() {
        // console.log('我被执行啦')
        const hm = document.createElement('script')
        hm.src = 'https://hm.baidu.com/hm.js?e201a9d2253413310246c4c132364245?hidden=1'
        document.head.appendChild(hm)
      })()
    },
  },
}
